export enum ConfigErrorCauses {
    DISABLED = 'disabled',
    HOST_NOT_FOUND = 'host-not-found',
    MISSING_IDGROUP = 'missing-id-group',
    MISSING_LEADSYSTEM = 'missing-lead-system',
    MISSING_LINKDISCLAIMER = 'missing-link-disclaimer',
    MISSING_MAIL = 'missing-mail',
}

export class ConfigError extends Error {
    cause: ConfigErrorCauses;

    errorName: string;

    constructor(cause: ConfigErrorCauses) {
        super();
        this.cause = cause;
        this.name = 'ConfigError';
    }
}
